import React from 'react';
import PropTypes from 'prop-types';
import ResponsibleChangeOfferItem from './ResponsibleChangeOfferItem';
import { Table, TableCell, TableRow, TableBody, Tooltip } from '@mui/material';
import { CheckboxWrapper } from '../ResponsibleChangeStyles';
import { useTranslation } from 'react-i18next';
import { BoldTableHead } from 'components/common/CommonStyles';

const ResponsibleChangeOfferList = ({ responsibleChangeOffers, onAllocateOffers, selectedOfferList, checkAllOffers, handleCheckAll }) => {
  const [t] = useTranslation();
  return (
    <Table>
      <BoldTableHead>
        <TableRow>
          <TableCell>
            {
              <Tooltip title={t('SelectAll')}>
                <CheckboxWrapper checked={checkAllOffers} onChange={handleCheckAll} />
              </Tooltip>
            }
          </TableCell>
          <TableCell>{t('OfferResponsibleChange.OfferNumber')}</TableCell>
          <TableCell>{t('OfferResponsibleChange.OfferClient')}</TableCell>
          <TableCell>{t('OfferResponsibleChange.OfferState')}</TableCell>
          <TableCell>{t('OfferResponsibleChange.Responsible')}</TableCell>
          <TableCell>{t('OfferResponsibleChange.Dealer')}</TableCell>
        </TableRow>
      </BoldTableHead>
      <TableBody>
        {responsibleChangeOffers.map((item, idx) => {
          return (
            <ResponsibleChangeOfferItem
              key={idx}
              item={item}
              index={idx}
              onAllocateOffers={onAllocateOffers}
              selectedOfferList={selectedOfferList}
            />
          );
        })}
      </TableBody>
    </Table>
  );
};

ResponsibleChangeOfferList.propTypes = {
  responsibleChangeOffers: PropTypes.array.isRequired,
  onAllocateOffers: PropTypes.func.isRequired,
  selectedOfferList: PropTypes.array,
  handleCheckAll: PropTypes.func,
  checkAllOffers: PropTypes.bool
};

export default ResponsibleChangeOfferList;
